(function () {
  'use strict';

  /* @ngdoc object
   * @name main.dades
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris.main.submain.dades', [
      'ui.router'
    ]);
}());
